module.exports = __webpack_public_path__ + "img/oformite-mob.418edf83.png";